import React from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/ProjectsAndVessels/Projects/add';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { v3_add_project } from '../../../actions/v3/projectAndVessel';

const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_project(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.listProject.url);
            } else {
                toast.error(res.error || "Failed to create project");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("An unexpected error occurred");
        });
    };

    return (
        <React.Fragment>
            <Layout title="Projects and Vessels">
                <Form
                    title="Add Project"
                    onSubmit={onSubmit}
                    buttonName="Create Project"
                />
            </Layout>
        </React.Fragment>
    );
};

export default Add;
